import { zetApi } from '@zet/network'

import { ISaveUserConsents } from './types'

export const getUserConsents = async (
  partnerId: number,
  customerId: number,
  ipAddress: string
) => {
  zetApi.defaults.headers.common = {
    ...zetApi.defaults.headers.common,
    ipAddress: ipAddress,
  }
  const { data } = await zetApi.get(
    `integration/customer/kreditbee/getConsents?partnerId=${partnerId}&customerId=${customerId}`
  )
  return data
}

export const saveUserConsents = async ({
  consentIds,
  partnerId,
  customerId,
  ipAddress,
}: ISaveUserConsents) => {
  zetApi.defaults.headers.common = {
    ...zetApi.defaults.headers.common,
    ipAddress: ipAddress,
  }
  const response = await zetApi.post(
    `/integration/customer/kreditbee/saveConsents?partnerId=${partnerId}&customerId=${customerId}`,
    consentIds
  )
  return response
}
